import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'distanza'
})

export class DistanzaPipe implements PipeTransform {
    /**
     * setto la distanza in base al parametro passato
     * @param  {number} value
     */
    transform(value: number): string {
        let distanza: string = '<i class="fas fa-ruler-horizontal" title="Distanza"></i> ' +  (value == null ? '0' : value.toString().substring(0, value.toString().lastIndexOf('.') )     ) + ' m';
        return distanza;
    }
}